import { PrismicRichText, Pris } from "@prismicio/react";

/**
 * Text slice component
 */
export const VideoSlice = ({ slice }) => {
  const s = slice?.primary?.youtube_link?.url?.split('/')

  if(!s?.length) {
    return null;
  }

  return <div className="post-part single container" style={{marginTop: 30}}>

   <iframe width="500" height="315"
src={`https://www.youtube.com/embed/${s?.[s?.length -1]}?autoplay=1&mute=1`  }>
</iframe>

  </div>
};

